import { render, staticRenderFns } from "./ProductsSlide.vue?vue&type=template&id=9b1bd7fa"
import script from "./ProductsSlide.vue?vue&type=script&lang=js"
export * from "./ProductsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports